<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Tabs :value="currentRoute" @on-click="changeRouter">
        <TabPane name="trackplanlist" label="追踪计划列表"></TabPane>
        <TabPane name="trackplanadd" :label="`${edit ? '修改' : '新建'}追踪计划`" v-if="currentRoute === 'trackplanadd'"></TabPane>
      </Tabs>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'dmpmanagelayout',
  computed: {
    authList() {
      return isArray(this.access) && this.access.includes('M20804')
    },
    authSplit() {
      return isArray(this.access) && this.access.includes('M20805')
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      // this.edit = (this.$route.query.t === 'edit')
      this.currentRoute = this.$route.name
      if (this.$route.name === 'trackplan') this.changeRouter('trackplanlist')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      edit: false,
      currentRoute: '',
      access: this.$store.state.accessAuth
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
<style lang="scss" scoped>
</style>
